import { User } from '@qality/common-model';
import {
  StorageOfUniqueServices,
  UserPropertyService,
  UserService,
} from '@qality/common-service';
import { Property } from '@qality/common-service/src/UserPropertyService';

export const ONBOARDING_PANEL_VISIBILITY_PROPERTY_KEY =
  'soldevelo-onboarding-playlist-visibility';

export const ONBOARDING_PANEL_EXPANDED_PROPERTY_KEY =
  'soldevelo-onboarding-playlist-expanded';

export default {
  async shouldShowOnboardingPlaylist(user): Promise<boolean> {
    const propertyResult: boolean = await this.getUserProperty(
      user,
      ONBOARDING_PANEL_VISIBILITY_PROPERTY_KEY
    );

    if (!propertyResult) {
      return false;
    }
    const isNewUser = await UserService.fetchIsNewUser();
    return isNewUser;
  },

  async getUserProperty(user: User, key: string): Promise<boolean> {
    let userProperty: boolean;
    try {
      const response: Property = await UserPropertyService.getProperty(
        key,
        user
      );
      userProperty = response.value;
    } catch (e) {
      if (e.xhr?.status === 404) {
        return true;
      } else {
        return false;
      }
    }
    return userProperty;
  },

  async setUserProperty(user, property: boolean, key: string) {
    try {
      await UserPropertyService.setProperty(key, property, user);
    } catch (e) {
      StorageOfUniqueServices.get('ErrorHandlingUtils').handleError(
        e,
        'Failed to set user property ' +
          ONBOARDING_PANEL_VISIBILITY_PROPERTY_KEY
      );
    }
  },
};
